import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import * as moment from 'moment-timezone';
import { EMPTY, Observable, Subscription, throwError } from 'rxjs';
import { catchError, delay, finalize, map, retryWhen, tap, } from 'rxjs/operators';
import { AppConstants } from 'src/app/constants/app.constant';
import { LoaderService } from '../helper/loader.service';
import { LocalStorage } from '../helper/localStorage';
import { BaseComponent } from '../base/base.component';
import { SessionService } from '@app/shared/session.service';

@Injectable({ providedIn: 'root' })
export class DefaultInterceptor extends BaseComponent<any> implements HttpInterceptor
{
  protected localStorage: LocalStorage;
  constructor(public router: Router, private loaderService: LoaderService,
    private _sessionService: SessionService,
    ) {
    super(_sessionService);
    this.localStorage = AppConstants.injector.get(LocalStorage);
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const timezone = moment?.tz?.guess() ?? '';
    const accessToken = localStorage.getItem('accessToken');
    const selectedCompanyId = localStorage.getItem('companyId');
    const sessionId = JSON.parse(localStorage.getItem('sessionId'));
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    let isEndWithSession = this.checkURL(req?.url);
    if (!sessionId && !isEndWithSession) {

      this.stopInterceptorRequest();
      this.goto(`/user/login`);
    }

    const loader : Subscription  = this.loaderService.loader$.subscribe();
    
    const modified = req.clone({ setHeaders: { Authorization: accessToken ? accessToken : 'xxx', companyId: selectedCompanyId ? selectedCompanyId : '', user: currentUser?._id ? currentUser?._id : '', sessionId: sessionId ? sessionId : '', timezone: timezone }});
    return next.handle(modified).pipe(
      catchError((err) => {


        if (err instanceof HttpErrorResponse) {

          switch ((<HttpErrorResponse>err).status) {
            case 400:
              return throwError(err);
            case 401:
              this.goto(`/user/login`);
              break;
            case 403:
              this.goto(`/user/login`);
              break;
            case 440:
              localStorage.setItem('sessionId', null);
              this.goto(`/user/login`);
              break;
            case 444:
              if (sessionId != null){
                this.goto(`/app/subscription/subscription-list`);
              }
            case 445:
              if (sessionId != null){
                this.showError("You are not authorized","Error");
                this.goto(`/app/dashboards/default`);
              }
              break;
            default:
              return throwError(err);
          }
        }
        else {

          return throwError(err);
        }
      }),
      retryWhen((err) => {

        let retries = 1;

        return err.pipe(delay(1000), tap(() => { }), map((error) => {

            if (error.status === 403) throw error;
            if (retries++ === 1) throw error;
            return error;
          })
        );
      }),
      finalize(() => {
        loader.unsubscribe();
      })
    );
  }

  private goto(url: string) {

    setTimeout(() => this.router.navigateByUrl(url));
  }

  private stopInterceptorRequest() {

    return EMPTY;
  }

  private checkURL(key: string) {

    // this work on http or https
    let isUrlCorrect = true;
    let keyValueOf = new String(key).valueOf();

    if (!!keyValueOf.match(/sessions$/gi)) {

      switch (keyValueOf) {
        case new String('http://localhost:1337/api/sessions').valueOf():
          isUrlCorrect = this.checkSessionUrl(keyValueOf);
          break;
        case new String('http://api.oms.com:1337/api/sessions').valueOf():
          isUrlCorrect = this.checkSessionUrl(keyValueOf);
          break;
        case new String('https://qa.shipkardo.pk/api/sessions').valueOf():
          isUrlCorrect = this.checkSessionUrl(keyValueOf);
          break;
        case new String('http://api.shipkardo.pk:54321/api/sessions').valueOf():
          isUrlCorrect = this.checkSessionUrl(keyValueOf);
          break;
        case new String('https://api.shipkardo.pk:54321/api/sessions').valueOf():
          isUrlCorrect = this.checkSessionUrl(keyValueOf);
          break;
        default:
          break;
      }
    }
    else if (!!keyValueOf.match(/registerUser$/gi)) {

      switch (keyValueOf) {
        case new String('http://localhost:1337/api/user/registerUser').valueOf():
          isUrlCorrect = this.checkRegisterUrl(keyValueOf);
          break;
        case new String('http://api.oms.com:1337/api/user/registerUser').valueOf():
          isUrlCorrect = this.checkRegisterUrl(keyValueOf);
          break;
        case new String('https://qa.shipkardo.pk/api/user/registerUser').valueOf():
          isUrlCorrect = this.checkRegisterUrl(keyValueOf);
          break;
        case new String('http://qa.shipkardo.pk/api/user/registerUser').valueOf():
          isUrlCorrect = this.checkRegisterUrl(keyValueOf);
          break;
        case new String('http://api.shipkardo.pk:54321/api/user/registerUser').valueOf():
          isUrlCorrect = this.checkRegisterUrl(keyValueOf);
          break;
        case new String('https://api.shipkardo.pk:54321/api/user/registerUser').valueOf():
          isUrlCorrect = this.checkRegisterUrl(keyValueOf);
          break;
        default:
          break;
      }
    }
    else if (keyValueOf.includes("forgetpassword")) {

      switch (keyValueOf) {
        case (this.checkUrlLocal(keyValueOf, "forgetpassword", "localhost")):
          isUrlCorrect = this.checkForgotPasswordUrl(keyValueOf);
          break;
        case (this.checkUrlLocal(keyValueOf, "forgetpassword", "api.oms.com")):
          isUrlCorrect = this.checkForgotPasswordUrl(keyValueOf);
          break;
        case (this.checkUrlLocal(keyValueOf, "forgetpassword", "qa.shipkardo.pk")):
          isUrlCorrect = this.checkForgotPasswordUrl(keyValueOf);
          break;
        case (this.checkUrlLocal(keyValueOf, "forgetpassword", "api.shipkardo.pk:54321")):
          isUrlCorrect = this.checkForgotPasswordUrl(keyValueOf);
          break;

        default:
          break;
      }
    }
    else if (keyValueOf.includes("resetpassword")) {

      switch (keyValueOf) {
        case (this.checkUrlLocal(keyValueOf, "resetpassword", "localhost")):
          isUrlCorrect = this.checkResetPasswordUrl(keyValueOf);
          break;
        case (this.checkUrlLocal(keyValueOf, "resetpassword", "api.oms.com")):
          isUrlCorrect = this.checkResetPasswordUrl(keyValueOf);
          break;
        case (this.checkUrlLocal(keyValueOf, "resetpassword", "qa.shipkardo.pk")):
          isUrlCorrect = this.checkResetPasswordUrl(keyValueOf);
          break;
        case (this.checkUrlLocal(keyValueOf, "resetpassword", "api.shipkardo.pk:54321")):
          isUrlCorrect = this.checkResetPasswordUrl(keyValueOf);
          break;

        default:
          break;
      }
    }
    else if (keyValueOf.includes("Public")) {

      isUrlCorrect = true
    }
    else {

      isUrlCorrect = false
    }

    return isUrlCorrect;
  }

  checkUrlLocal(url, api, appUrl) {

    const urlLocal = url;
    return urlLocal.split(api)[0].includes(appUrl);
  }

  checkRegisterUrl(keyValueOf: string) {

    return !!keyValueOf.match(/registerUser$/gi);
  }

  checkSessionUrl(keyValueOf: string) {

    return !!keyValueOf.match(/sessions$/gi);
  }

  checkForgotPasswordUrl(keyValueOf: string) {

    return !!keyValueOf.match(/forgetpassword$/gi);
  }

  checkResetPasswordUrl(keyValueOf: string) {

    return !!keyValueOf.match(/resetpassword$/gi);
  }
}
